/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./manage-forbidden-font.vue?vue&type=template&id=5ceeec16&scoped=true&"
import script from "./manage-forbidden-font.vue?vue&type=script&lang=ts&"
export * from "./manage-forbidden-font.vue?vue&type=script&lang=ts&"
import style0 from "./manage-forbidden-font.vue?vue&type=style&index=0&id=5ceeec16&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ceeec16",
  null
  
)

export default component.exports